import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import {Container} from 'reactstrap';

import {
  AppFooter,
  AppHeader,
} from '@coreui/react';

import routes from '../../routes';
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import '../Reception/Style.css'

import DefaultFooter from './OrganizerFooter'
import DefaultHeader from './OrganizerHeader'
import Cookies from "js-cookie";

class DefaultLayout extends Component {

  loading = () => <span/>;

  signOut(e) {
    e.preventDefault();
    Cookies.remove("68a6102f6ed24899420170004a0273b8");
    this.props.history.push('/login')
  }

  componentDidMount() {
    document.title = "EventTags";
  }

  render() {
    return (
      <div className="app">
        <AppHeader fixed>

          <DefaultHeader onLogout={e => this.signOut(e)}/>

        </AppHeader>
        <div className="app-body">
          <main className="main recept external-recept" style={{marginLeft: '0px!important'}}>

            <Container fluid>

              <Switch>
                {routes.map((route, idx) => {
                  return route.component ? (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={props => (
                        <route.component route_name={route.name} {...props} />

                      )}/>
                  ) : (null);
                })}
                {/*<Redirect from="/" to="/login" />*/}
              </Switch>

            </Container>
          </main>
        </div>
        <AppFooter className={"footer-recept"}>

          <DefaultFooter/>

        </AppFooter>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  is_spin: state.spinnerReducer.is_spin,
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    callAllCount: (data) => dispatch(actionCreator.callAllCount(data)),
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // history reducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout);
